import React from 'react';
import InfoCard from '../../common/InfoCard/InfoCard';
import { CardChangeButton } from '../../../../../components/Card';
import StatusCard from '../StatusCard/StatusCard';
import styles from './StatusBlock.module.scss';

const StatusBlock = ({
  statuses,
  indicator,
  onActionClick,
  actionText = 'Подробнее',
  title,
  indicatorBgColor,
}) => {
  return (
    <InfoCard
      className={styles.root}
      title={title}
      action={
        typeof onActionClick === 'function' && (
          <CardChangeButton
            text={actionText}
            onClick={onActionClick}
          />
        )
      }
    >
      {statuses.map((status) => (
        <StatusCard
          key={status.id}
          className={styles.card}
          status={status}
          indicator={indicator}
          indicatorBgColor={
            typeof indicatorBgColor === 'function'
              ? indicatorBgColor(status.id)
              : indicatorBgColor
          }
        />
      ))}
    </InfoCard>
  );
};

export default StatusBlock;
